// extracted by mini-css-extract-plugin
export default {"root":"UnreadMessages_root__0RTvM","root--only-current":"UnreadMessages_root--only-current__jfF3J","item":"UnreadMessages_item__SOLUQ"};